module.exports = __webpack_public_path__ + "static/media/favorites.0212dbee.svg";